export default __webpack_public_path__ + "static/media/22.02e4e60a.jpg";